import * as t from "io-ts";
import nullable from "./nullable";
export const userT = t.strict({
    id: t.string,
    firstName: t.string,
    lastName: t.string,
    fullName: t.string,
});
export const trailerRouteT = t.strict({
    name: t.string,
    destination: nullable(t.string),
    destinationDate: t.string,
    owner: userT,
    active: t.boolean,
    drivers: t.array(t.string),
});
export const trailerRoutesT = t.array(trailerRouteT);
export const trailerRoutesByTrailerIdT = t.record(t.string, trailerRoutesT);
//# sourceMappingURL=fleet.js.map